import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "src/pages/Dashboard";
import InventoryPage from "src/pages/Submission/InventoryPage";
import InventoryPageVersionTwo from "src/pages/Submission/InventoryPageVersionTwo";
import NotFound from "src/pages/NotFound";
import SubmissionDetails from "src/pages/SubmissionDetails";
import UtilitiesPage from "src/pages/Utilities";
import UtilityDetailsPage from "src/pages/UtilityDetails";
import { SubmissionServiceLineDetails } from "src/pages/SubmissionServiceLineDetails";
import Layout from "./Layout";
import AccountSettingsPage from "src/pages/Administration";
import { useConfig, Flags } from "src/hooks/useConfig";
import UtilityDetailsInventoryPage from "src/pages/UtilityDetailsInventory";
import CustomerNoticeCertificationPage from "src/pages/Submission/CustomerNoticeCertificationPage";
import UtilityDetailsCustomerNoticeCertificationPage from "src/pages/UtilityDetailsCustomerNoticeCertification";

interface Props {
  isLoading?: boolean;
}

const AppRoutes: React.FC<Props> = ({ isLoading = false }) => {
  const [useNewSubmissionType] = useConfig(Flags.newSubmissionType);
  return (
    <Layout isLoading={isLoading}>
      <Routes>
        <Route path={"/"} element={<Navigate to="/insights" />} />
        <Route element={<Dashboard />} path="/insights" />

        {!useNewSubmissionType && (
          <>
            <Route element={<InventoryPage />} path="/submissions" />
            <Route element={<UtilityDetailsPage />} path="/utilities/:id" />
          </>
        )}
        {useNewSubmissionType && (
          <>
            <Route element={<InventoryPageVersionTwo />} path="/submissions" />
            <Route
              element={<CustomerNoticeCertificationPage />}
              path="/submissions/customerNoticeCertification"
            />
            <Route
              element={<UtilityDetailsInventoryPage />}
              path="/utilities/:id"
            />
            <Route
              element={<UtilityDetailsCustomerNoticeCertificationPage />}
              path="/utilities/:id/customerNoticeCertification"
            />
          </>
        )}
        <Route element={<SubmissionDetails />} path="/submissions/:id" />
        <Route
          element={<SubmissionServiceLineDetails />}
          path="/submissions/:submissionId/servicelines/:serviceLineId"
        />
        <Route element={<UtilitiesPage />} path="/utilities" />
        <Route element={<NotFound />} path="*" />
        <Route
          element={<AccountSettingsPage />}
          path="/accountSettings/*"
        ></Route>
      </Routes>
    </Layout>
  );
};

export default AppRoutes;
